/**
 * Centralized asset paths — single source of truth for all public/assets/ references.
 * Always use this module instead of hardcoding `/assets/...` strings in components.
 */

export const LOGOS = {
  treeYellow: '/assets/logos/tree-yellow.svg',
  treeWhite: '/assets/logos/tree-white.svg',
  treePurple: '/assets/logos/tree-purple.svg',
  wordmark: '/assets/logos/wordmark.svg', // pending export from Figma
  icon: '/assets/icons/icon.png',
  iconText: '/assets/icons/iconText.png',
} as const;

export const CERTIFICATE_ICONS = {
  iso9001: '/assets/certificates/iso9001.png',
  iso27001: '/assets/certificates/iso27001.png',
  iso37001: '/assets/certificates/iso37001.png',
} as const;

/** Full-page renders of each certificate, shown inside CertificadoModal. */
export const CERTIFICATE_IMAGES = {
  iso9001: '/assets/certificates/iso9001-certificado.jpg',
  iso27001: '/assets/certificates/iso27001-certificado.jpg',
  iso37001: '/assets/certificates/iso37001-certificado.jpg',
} as const;

export const CERTIFICATE = {
  iso9001: '/assets/documents/ISO9001.pdf',
  iso27001: '/assets/documents/ISO27001.pdf',
  iso37001: '/assets/documents/ISO37001.pdf',
} as const;

export const DOCUMENTS = {
  privacyPolicy: '/assets/documents/politica_privacidade.pdf',
  compliancePolicy: '/assets/documents/politica_anticorrupcao.pdf',
} as const;

/**
 * Per-page imagery. Each slot is named after its visual role (not sequence)
 * so swapping order in Figma doesn't break the mapping.
 *
 * Drop new files in /public/assets/images/<page-slug>/ and add the path here.
 */
export const PAGE_IMAGES = {
  home: {
    heroBg: '/assets/images/home/hero-bg.png',
    subheroBg: '/assets/images/home/subhero-bg.png',
    diferenciais1: '/assets/images/diferenciais/diferenciais-1.png',
    diferenciais2: '/assets/images/diferenciais/diferenciais-2.png',
  },
  nossaEssencia: {
    hero: '/assets/images/nossa-essencia/hero.png',
    comprometimento: '/assets/images/nossa-essencia/comprometimento.png',
    flexibilidade: '/assets/images/nossa-essencia/flexibilidade.png',
    simplicidade: '/assets/images/nossa-essencia/simplicidade.png',
    inovacao: '/assets/images/nossa-essencia/inovacao.png',
  },
  comoFunciona: {
    bi: '/assets/images/como-funciona/bi.png',
  },
  privacidade: {
    confianca: '/assets/images/privacidade/confianca.png',
  },
  sejaNossoParceiro: {
    heroBg: '/assets/images/seja-nosso-parceiro/hero-bg.png',
  },
  trabalheConosco: {
    team: '/assets/images/trabalhe-conosco/trabalhe-conosco-1.png',
  },
} as const;
